import { createMask, MaskedRange } from "imask";

export const createCreditCardNumberMask = () => createMask({ 
    mask: "0000 0000 0000 0000"
});

export const createCreditCardExpiryMask = () => createMask({ 
    mask: "MM/AA",
    blocks: {
        MM: {
            mask: MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2
        },
        AA: {
            mask: MaskedRange,
            from: 0,
            to: 99,
            maxLength: 2
        }
    }
});
